import React from 'react';
import { Box, Stack } from '@chakra-ui/react';

import { ProfileField } from '../elements/ProfileField';
import { ProfileSelect } from '../elements/ProfileSelect';
import { ProfileTextarea } from '../elements/ProfileTextarea';
import { fields } from '../data';
import { makeFields } from './utils';

export const Personal = ({ user, setUser, handleUpdate }) => {
	const {
		firstName,
		lastName,
		email,
		phoneNumber,
		citizenship,
		residence,
		city,
		maritalStatus,
		birthDate,
		age,
		children,
		criminality,
		healthIssues,
		visaRefusals,
		tripsAbroad,
		relatives,
		questions,
		financial,
		channel,
		channelDetails,
		englishSkills,
		enCert,
		frenchSkills,
		frCert,
	} = makeFields(user, setUser, fields, handleUpdate);

	const isDetailed = ['forum', 'socnet', 'referral', 'other'].includes(
		user.channel
	);
	return (
		<Box>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...firstName} />
				<ProfileField pb={6} {...lastName} />
				<ProfileField pb={6} {...email} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileSelect pb={6} {...citizenship} />
				<ProfileSelect pb={6} {...residence} />
				<ProfileField pb={6} {...city} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...birthDate} />
				<ProfileField pb={6} {...age} />
				<ProfileSelect pb={6} {...maritalStatus} />
				<ProfileField pb={6} {...phoneNumber} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...children} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...criminality} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...healthIssues} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...visaRefusals} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...tripsAbroad} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...relatives} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileTextarea pb={6} {...questions} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} w={['100%', '33%']} {...financial} />
				<ProfileSelect pb={6} w={['100%', '33%']} {...channel} />
				{isDetailed && (
					<ProfileField pb={6} w={['100%', '33%']} {...channelDetails} />
				)}
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileSelect pb={6} {...englishSkills} />
				<ProfileField pb={6} {...enCert} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileSelect pb={6} {...frenchSkills} />
				<ProfileField pb={6} {...frCert} />
			</Stack>
		</Box>
	);
};
